import { useMemo } from "react";
import { connect } from "react-redux";
import { firebaseConnect, isLoaded } from "react-redux-firebase";
import { get } from "lodash";
import { PaymentSetupData } from "../../../../../utils/firebase/paymentSetup";

export interface PaymentProgress {
  completedSteps: number;
  totalSteps: number;
  isLoaded: boolean;
}

export const usePaymentProgress = (
  charityId: string,
  paymentSetupData: PaymentSetupData | null,
  paymentSetupLoaded: boolean
): PaymentProgress => {
  return useMemo(() => {
    const totalSteps = 1;

    if (!paymentSetupLoaded) {
      return {
        completedSteps: 0,
        totalSteps,
        isLoaded: false,
      };
    }

    let completedSteps = 0;

    if (!paymentSetupData || !paymentSetupData.paymentMethod) {
      completedSteps = 0;
    } else if (paymentSetupData.paymentMethod === "customUrl") {
      if (paymentSetupData.customDonationUrl && paymentSetupData.progressTracker === "url_configured") {
        completedSteps = 1;
      }
    } else if (paymentSetupData.paymentMethod === "giveSpark") {
      if (paymentSetupData.stripeConnected && paymentSetupData.progressTracker === "stripe_connected") {
        completedSteps = 1;
      }
    }

    return {
      completedSteps,
      totalSteps,
      isLoaded: true,
    };
  }, [paymentSetupData, paymentSetupLoaded]);
};

const withPaymentProgress = (WrappedComponent: React.ComponentType<any>) => {
  const mapStateToProps = (state: any) => {
    const { user, firebase } = state;
    const charityId = user.currentCharity?.id || "";

    const paymentSetupLoaded =
      charityId &&
      isLoaded(firebase.data[charityId]) &&
      isLoaded(get(firebase, `data.${charityId}.charitySetup.payment`));

    const paymentSetupData: PaymentSetupData | null = paymentSetupLoaded
      ? get(firebase, `data.${charityId}.charitySetup.payment`, null)
      : null;

    return {
      charityId,
      paymentSetupData,
      paymentSetupLoaded,
    };
  };

  return connect(mapStateToProps)(
    firebaseConnect((props: any, store: any) => {
      const charityId = store.getState().user.currentCharity?.id;
      return charityId ? [`${charityId}/charitySetup/payment`] : [];
    })(WrappedComponent)
  );
};

export { withPaymentProgress };